import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    title: 'Add Funds',
    balanceLabel: '{unit} Amount',
    submit: 'Deposit',
    yourBalance: 'Your Balance: {value}',
  },
};
